module.exports = __webpack_public_path__ + "static/media/eggette.6c1af0dc.png";